import { FlightAvailabilityToCheckin } from 'src/common/interface';
/**
 * FlightAvailabilityToCheckin model details
 */
export interface FlightAvailabilityToCheckinStateDetails {}

/**
 * FlightAvailabilityToCheckin store state
 */
export interface FlightAvailabilityToCheckinState extends FlightAvailabilityToCheckinStateDetails {
  model: FlightAvailabilityToCheckin;
}

/**
 * Name of the FlightAvailabilityToCheckin Store
 */
export const FLIGHT_AVAILABILITY_TO_CHECKIN_STORE_NAME = 'flightAvailabilityToCheckin';

/**
 * FlightAvailabilityToCheckin Store Interface
 */
export interface FlightAvailabilityToCheckinStore {
  /** FlightAvailabilityToCheckin state */
  [FLIGHT_AVAILABILITY_TO_CHECKIN_STORE_NAME]: FlightAvailabilityToCheckinState;
}
